<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
  .sub-title 
    | 請選擇您想要進行智慧租賃商品
  .rental-type
    .rental-item(v-for="item in $root.types" @click="selectItem(item.id)" ) 
      .rental-item-img(:class="{active: now_select === item.id}")
        img.type-img(:src="item.img")
        .on-select(v-if="now_select === item.id")
          img(src="../assets/images/check.svg")
      .rental-item-title(v-html="item.title")
      .rental-item-text {{ item.description }}
  .button-group
    button.stepUp(type="button" @click="$router.go(-1)") 
      .step-txt 上一步
    button.stepNext(type="button" @click="goNext" :class="{active: now_select}") 
      .step-txt 下一步
</template>

<script>
export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
      now_select: false
    };
  },
  mounted () {
    this.now_select = false
  },
  methods: {
    selectItem (_id) {
      this.now_select = _id
      this.$root.register.itemType = _id
    },
    goNext () {
      if (this.now_select) {
        // this.$root.register.carTypes = this.now_select
        this.$root.goPage('/reserve-select-sub-type')
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  padding: 48px 5vmin
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
  .sub-title
    font-size: 18px
    font-weight: 700
    color: #898A8D
    padding-top: 34px
  .rental-type
    margin-top: 20px
    display: flex
    flex-wrap: wrap
    gap: 47px 6.3vmin
    margin-bottom: 5vh
    .rental-item
      width: calc((100% - 12.6vmin) / 3)
      .rental-item-img
        position: relative
        margin-bottom: 10px
        border: 2px solid #202020
        border-radius: 21px
        &.active
          border: 2px solid #22F48F
          
        img.type-img
          border-radius: 20px
          
        .on-select
          width: 47px
          height: 47px
          border-radius: 5px 0 15px 0
          background: #22F48F
          position: absolute
          right: -1px
          bottom: -1px
          display: flex
          align-items: center
          img
            width: 18px
            
      .rental-item-title
        color: #22F48F
        font-size: 3.4vmin
        letter-spacing: -0.5px
        line-height: 5vmin
        text-align: center
        margin-bottom: 5px
      .rental-item-text
        font-size: 3vmin
        font-weight: 500
        line-height: 4vmin
        color: #fff
        text-align: center
        letter-spacing: -0.4px
      
      
  .button-group
    display: flex
    .stepUp
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #fff
      border: none
      padding: 3vmin 0px
    .stepNext
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #898A8D
      border: none
      padding: 3vmin 0px
      &.active
        background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
</style>
